export const ValidationErrorComponent = ({ error, type, message }) => {
    return (
        <div>
            {error && error.type === type && (
                <span role="alert">{message}</span>
            )}
        </div>
    )

}